import * as types from './company-contexts.types';
import { generateResourceSelectors } from '../generators/resource.selectors';

export const companyContextsSelectors = generateResourceSelectors<types.ICompanyContext>(
  (state) => state.resource.companyContexts,
);
